import { configureStore } from '@reduxjs/toolkit'
import bannerReducer from './slices/banner'
import affiliateReducer from './slices/affiliate'
import affiliateMembersReducer from './slices/affiliateMembers'
import affiliateCompetitionsReducer from './slices/affiliateCompetitions'

export const store = configureStore({
  reducer: {
    banner: bannerReducer,
    affiliate: affiliateReducer,
    affiliateMembers: affiliateMembersReducer,
    affiliateCompetitions: affiliateCompetitionsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
